import type { ExtendedConstraints, CapabilityConfig } from '../../../types';
import { hasValue } from '../../../utils';
import * as AppletSpec from '../applet/applet';

export const id = 'overlay-applet';

export enum Events {}
export enum Actions {
  Attach = 'overlay-applet:attach',
  Detach = 'overlay-applet:detach',
}

export enum Variant {
  Modal = 'modal',
}
const variantValues = Object.values(Variant) as string[];

export type Applet = AppletSpec.Applet & {
  variant?: Variant;
};

const VALID_CONFIG_KEYS = [
  ...AppletSpec.VALID_CONFIG_KEYS,
  'attach',
  'variant',
] as const;
export type Config = AppletSpec.Config & {
  type: typeof id;
  attach?: boolean;
  variant?: Variant;
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;

  actionPayloadTuple:
    | [Actions.Attach]
    | [Actions.Detach]
    | [Actions.Attach, AppletSpec.AppletPayload]
    | [Actions.Detach, AppletSpec.AppletPayload];
}>;

export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!AppletSpec.isValidConfig(config, VALID_CONFIG_KEYS)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  const isAttachNotValid =
    hasValue(config, 'attach') && typeof config.attach !== 'boolean';

  if (isAttachNotValid) {
    return false;
  }

  const isVariantNotValid =
    hasValue(config, 'variant') &&
    (typeof config.variant !== 'string' ||
      !variantValues.includes(config.variant));

  if (isVariantNotValid) {
    return false;
  }

  return true;
}
